let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("lf3j4")).then(() => parcelRequire('lXOAp'));